import { ParseKeys } from 'i18next'
import {
  DebtStatusesEnum,
  DebtSourceTypesEnum,
  TimezoneCode,
  LocaleEnum,
} from '~/shared/config/enums'
import { myPalette } from '~/shared/lib/theme'

export const AUTH_TOKEN_STORAGE_KEY = 'auth_token'
export const AUTH_EMAIL_STORAGE_KEY = 'auth_email'
export const AUTH_CURRENT_USER_ID_STORAGE_KEY = 'auth_current_user_id'
export const USER_PERMISSIONS_STORAGE_KEY = 'user_permissions'
export const USER_LOCALE_STORAGE_KEY = 'user_locale'
export const USER_COUNTRY_STORAGE_KEY = 'user_country'
export const USER_DEPOSIT_BALANCE_ENABLED_STORAGE_KEY =
  'user_deposit_balance_enabled'

export const MIN_COLUMN_WIDTH = 90

export type Option = { id: string; label: string }
export type OptionEnum<T> = { id: T; label: string }

export const debtStatusEnumLabels: Record<DebtStatusesEnum, ParseKeys> = {
  [DebtStatusesEnum.PAID]: 'enum.paid',
  [DebtStatusesEnum.PROCESSING]: 'enum.processing',
  [DebtStatusesEnum.SUSPENDED]: 'enum.suspended',
}

export const debtStatusEnumOptions: OptionEnum<DebtStatusesEnum>[] =
  Object.keys(DebtStatusesEnum).map((value) => {
    const label = debtStatusEnumLabels[value as keyof typeof DebtStatusesEnum]
    return {
      label,
      id: value as DebtStatusesEnum,
    }
  })

export const debtTypeEnumLabels: Record<DebtSourceTypesEnum, ParseKeys> = {
  [DebtSourceTypesEnum.INSPECTION_VIOLATIONS]: 'enum.inspection violations',
  [DebtSourceTypesEnum.INSPECTION_DAMAGES]: 'enum.inspection damages',
  [DebtSourceTypesEnum.PLAN_INSPECTION_DELAY]:
    'enum.plan inspection delay software',
  [DebtSourceTypesEnum.EXTERNAL_PENALTY]: 'enum.external penalty gibdd',
  [DebtSourceTypesEnum.BALANCE_CORRECTION]: 'enum.balance correction',
  [DebtSourceTypesEnum.TOLL_ROAD]: 'enum.toll road',
  [DebtSourceTypesEnum.REDEMPTION_PAYMENT]: 'enum.redemption payment',
  [DebtSourceTypesEnum.OSAGO]: 'enum.osago',
  [DebtSourceTypesEnum.TIRES]: 'enum.tires',
  [DebtSourceTypesEnum.AUTO_TRANSMISSION]: 'enum.auto transmission',
  [DebtSourceTypesEnum.GBO]: 'enum.gbo',
  [DebtSourceTypesEnum.SERVICE]: 'enum.service',
  [DebtSourceTypesEnum.OTHER_CHARGES]: 'enum.other charge',
}

export const debtTypeEnumOptions: OptionEnum<DebtSourceTypesEnum>[] =
  Object.keys(DebtSourceTypesEnum).map((value) => {
    const label = debtTypeEnumLabels[value as keyof typeof DebtSourceTypesEnum]
    return {
      label,
      id: value as DebtSourceTypesEnum,
    }
  })

export const timezoneCodeLabels: Record<TimezoneCode, ParseKeys> = {
  [TimezoneCode.KALININGRAD]: 'timezone code.kaliningrad utc+2',
  [TimezoneCode.MOSCOW]: 'timezone code.moscow utc+3',
  [TimezoneCode.SAMARA]: 'timezone code.samara utc+4',
  [TimezoneCode.YEKATERINBURG]: 'timezone code.yekaterinburg utc+5',
  [TimezoneCode.OMSK]: 'timezone code.omsk utc+6',
  [TimezoneCode.KRASNOYARSK]: 'timezone code.krasnoyarsk utc+7',
  [TimezoneCode.IRKUTSK]: 'timezone code.irkutsk utc+8',
  [TimezoneCode.YAKUTSK]: 'timezone code.yakutsk utc+9',
  [TimezoneCode.VLADIVOSTOK]: 'timezone code.vladivostok utc+10',
  [TimezoneCode.MAGADAN]: 'timezone code.magadan utc+11',
  [TimezoneCode.KAMCHATKA]: 'timezone code.kamchatka utc+12',
}

export const localeEnumLabels: Record<LocaleEnum, ParseKeys> = {
  [LocaleEnum.ru]: 'locale.russian',
  [LocaleEnum.en]: 'locale.english',
  [LocaleEnum.fr]: 'locale.french',
}

export const localeEnumOptions: OptionEnum<LocaleEnum>[] = Object.keys(
  LocaleEnum,
).map((value) => {
  const label = localeEnumLabels[value as keyof typeof LocaleEnum]
  return {
    label,
    id: value as LocaleEnum,
  }
})

export const timezoneCodeOptions: OptionEnum<TimezoneCode>[] = Object.values(
  TimezoneCode,
).map((value) => ({
  label: timezoneCodeLabels[value as TimezoneCode],
  id: value as TimezoneCode,
}))

export const STATUS_VARIANT = {
  green: {
    backgroundColor: myPalette.green['100'],
    color: myPalette.green['600'],
  },
  outlinedGreen: {
    backgroundColor: myPalette.white.main,
    color: myPalette.green['600'],
    border: `1px solid ${myPalette.green['100']}`,
  },
  red: {
    backgroundColor: myPalette.red['100'],
    color: myPalette.red['600'],
  },
  outlinedRed: {
    backgroundColor: myPalette.white.main,
    color: myPalette.red['600'],
    border: `1px solid ${myPalette.red['600']}`,
  },
  gray: {
    backgroundColor: myPalette.gray['100'],
    color: myPalette.gray['700'],
  },
  yellow: {
    backgroundColor: myPalette.yellow['100'],
    color: myPalette.yellow['600'],
  },
  brand: {
    backgroundColor: myPalette.brand['100'],
    color: myPalette.brand['700'],
  },
  blue: {
    backgroundColor: myPalette.blue['100'],
    color: myPalette.blue['600'],
  },
  purple: {
    backgroundColor: myPalette.purple['100'],
    color: myPalette.purple['600'],
  },
}
